import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 
  import.meta.env?.VITE_SUPABASE_URL || 
  process.env.REACT_APP_SUPABASE_URL || 
  'https://cxqihhzpruwsbhhpxsvv.supabase.co';

const SUPABASE_ANON_KEY = 
  import.meta.env?.VITE_SUPABASE_ANON_KEY || 
  process.env.REACT_APP_SUPABASE_ANON_KEY || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN4cWloaHpwcnV3c2JoaHB4c3Z2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY0NTI3MzQsImV4cCI6MjA5MjAyODczNH0.uy3fchljTglWeFUszAbgIXl9hgBnufO-i-NQUSnwujA'; // 

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
